import { createSlice } from '@reduxjs/toolkit';

import { fetchAccessibilityDetails } from '../thunk/accessibility';

const accessibilitySlice = createSlice({
  name: 'accessibility',
  initialState: {
    details: null,
    error: null,
    loading: false,
  },
  reducers: {
    resetAccessibilityDetails: (state) => {
      state.details = null;
      state.error = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAccessibilityDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAccessibilityDetails.fulfilled, (state, action) => {
        state.details = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchAccessibilityDetails.rejected, (state, action) => {
        state.error =
          action.payload || action.error?.message || 'An error occurred';
        state.loading = false;
      });
  },
});

export const { resetAccessibilityDetails } = accessibilitySlice.actions;

export default accessibilitySlice.reducer;
